{
  "APP_TITLE": "Font Browser",
  "SELECT_FONT": "Select Font",
  "SEARCH_FONTS": "Search fonts...",
  "PREVIEW": "Preview",
  "GLYPHS": "Glyphs",
  "DOWNLOAD": "Download",
  "FONT_SIZE": "Font Size",
  "SAMPLE_TEXT": "Sample Text",
  "SHOW_GLYPHS": "Show all glyphs",
  "VARIABLE_AXES": "Variable Font Axes",
  "NO_VARIABLE_AXES": "This font has no variable axes",
  "GLYPH_COUNT": "Glyphs",
  "FONT_INFO": "Font Info",
  "IS_VARIABLE": "Variable Font",
  "YES": "Yes",
  "NO": "No",
  "COPIED": "Copied!",
  "CLICK_TO_COPY": "Click to copy"
}
